import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createReducer = ({
    DAR_SETTINGS = {},
    GENERAL_SETTINGS = {}
}) => {
    const darSettings = DAR_SETTINGS || {
        allowUsersToSeeAllTT: false,

        usersForSeeAllTTFilter: {
            all: false,
            userIds: [],
            groupIds: [],
            groupType: null,
        },

        showUsernameInReports: false,
        hideNotAssignedTTDetails: false,
        hideDetailsOnLockTT: false,
        hideAccountSettingsWhenDisabled: false,
        ttmCanSeeAutoApproved: false,
    }

    const darSettingsCollapsedState = {
        allowUsersToSeeAllTTCollapsed: true,
        showUsernameInReportsCollapsed: true,
        hideNotAssignedTTDetailsCollapsed: true,
        hideDetailsOnLockTTCollapsed: true,
        hideAccountSettingsCollapsed: true,
        ttmCanSeeAutoApprovedCollapsed: true,
        ...GENERAL_SETTINGS.DAR_SETTINGS_COLLAPSED_STATE
    }

    const initState = {
        ...darSettings,
        ...darSettingsCollapsedState,
    }

    return handleActions({
        [ActionTypes.ALLOW_USERS_TO_SEE_ALL_TT_SET]: (state, {payload: val}) => ({
            ...state,
            allowUsersToSeeAllTT: val,
        }),
        [ActionTypes.USERS_FOR_SEE_ALL_TT_FILTER_SET]: (state, {payload: val}) => ({
            ...state,
            usersForSeeAllTTFilter: val,
        }),
        [ActionTypes.SHOW_USERNAME_IN_REPORTS_SET]: (state, {payload: val}) => ({
            ...state,
            showUsernameInReports: val,
        }),
        [ActionTypes.HIDE_NOT_ASSIGNED_TT_DETAILS_SET]: (state, {payload: val}) => ({
            ...state,
            hideNotAssignedTTDetails: val,
        }),
        [ActionTypes.HIDE_DETAILS_ON_LOCK_TT_SET]: (state, {payload: val}) => ({
            ...state,
            hideDetailsOnLockTT: val,
        }),
        [ActionTypes.HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET]: (state, {payload: val}) => ({
            ...state,
            hideAccountSettingsWhenDisabled: val,
        }),
        [ActionTypes.TTM_CAN_SEE_AUTO_APPROVED_SET]: (state, {payload: val}) => ({
            ...state,
            ttmCanSeeAutoApproved: val,
        }),
        [ActionTypes.ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE]: (state, {payload: val}) => ({
            ...state,
            allowUsersToSeeAllTTCollapsed: val,
        }),
        [ActionTypes.SHOW_USERNAME_IN_REPORTS_COLLAPSE]: (state, {payload: val}) => ({
            ...state,
            showUsernameInReportsCollapsed: val,
        }),
        [ActionTypes.HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE]: (state, {payload: val}) => ({
            ...state,
            hideNotAssignedTTDetailsCollapsed: val,
        }),
        [ActionTypes.HIDE_DETAILS_ON_LOCK_TT_COLLAPSE]: (state, {payload: val}) => ({
            ...state,
            hideDetailsOnLockTTCollapsed: val,
        }),
        [ActionTypes.HIDE_ACCOUNT_SETTINGS_COLLAPSE]: (state, {payload: val}) => ({
            ...state,
            hideAccountSettingsCollapsed: val,
        }),
        [ActionTypes.TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE]: (state, {payload: val}) => ({
            ...state,
            ttmCanSeeAutoApprovedCollapsed: val,
        }),
    }, initState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/reducer.js